<template>
    <div class="basic_wrap">
        <!-- 顶部标题栏 -->
        <div class="loan_record_header">
            <div class="back_left" @click="$router.go(-1)">
                <img src="../../../src/assets/images/return.png" alt="返回">
            </div>
            <div class="big_tit">{{ $t('loan.recordTitle') }}</div>
        </div>

        <!-- 筛选区域 -->
        <div class="filter_section">
            <div class="filter_tabs">
                <div 
                    v-for="tab in statusTabs" 
                    :key="tab.value"
                    :class="['tab_item', { active: currentStatus === tab.value }]"
                    @click="changeStatus(tab.value)"
                >
                    {{ tab.label }}
                </div>
            </div>
        </div>

        <!-- 主要内容区域 -->
        <div class="main_content">
            <!-- 记录列表区域 -->
            <div class="records_container">
                <!-- 加载状态 -->
                <div v-if="loading" class="loading_state">
                    <div class="loading_text">{{ $t('loan.loading') }}</div>
                </div>
                
                <!-- 空状态 -->
                <div v-else-if="loanRecords.length === 0" class="empty_state">
                    <div class="empty_text">{{ $t('loan.noRecords') }}</div>
                </div>
                
                <!-- 记录列表 -->
                <div v-else class="record_list">
                    <div 
                        v-for="record in loanRecords" 
                        :key="record.id" 
                        class="record_item"
                    >
                        <div class="record_header">
                            <div class="loan_name">{{ record.loan_name }}</div>
                            <div class="record_status">
                                <span :class="getStatusClass(record.audit_status)">
                                    {{ getStatusText(record.audit_status) }}
                                </span>
                            </div>
                        </div>
                        
                        <div class="record_details">
                            <div class="detail_row">
                                <span class="label">{{ $t('loan.loanAmountLabel') }}</span>
                                <span class="value amount">{{ record.amount_formatted }}</span>
                            </div>
                            <div class="detail_row">
                                <span class="label">{{ $t('loan.loanPeriodLabel') }}</span>
                                <span class="value">{{ record.days }}{{ $t('loan.days') }}</span>
                            </div>
                            <div class="detail_row">
                                <span class="label">{{ $t('loan.interestLabel') }}</span>
                                <span class="value">{{ record.total_interest_formatted }}</span>
                            </div>
                            <div class="detail_row">
                                <span class="label">{{ $t('loan.totalAmountLabel') }}</span>
                                <span class="value total">{{ (parseFloat(record.amount) + parseFloat(record.total_interest)).toFixed(2) }}</span>
                            </div>
                            <div class="detail_row">
                                <span class="label">{{ $t('loan.applyTimeLabel') }}</span>
                                <span class="value">{{ record.apply_time_formatted }}</span>
                            </div>
                            <!-- <div v-if="record.repay_time_formatted" class="detail_row">
                                <span class="label">还款时间：</span>
                                <span class="value">{{ record.repay_time_formatted }}</span>
                            </div> -->
                        </div>

                        <!-- 操作按钮 -->
                        <div v-if="record.audit_status === 1" class="record_actions">
                            <button class="repay_btn" @click="repayLoan(record)">
                                {{ $t('loan.repayNow') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Fetch from '../../utils/fetch'
import { Toast } from 'vant'

export default {
    name: 'LoanRecord',
    data() {
        return {
            loading: false,
            loanRecords: [],
            currentStatus: 'all'
        }
    },

    computed: {
        statusTabs() {
            return [
                { label: this.$t('loan.all'), value: 'all' },
                { label: this.$t('loan.pending'), value: 0 },
                { label: this.$t('loan.approved'), value: 1 },
                { label: this.$t('loan.rejected'), value: 2 }
            ]
        }
    },
    mounted() {
        this.getLoanRecords()
    },
    methods: {
        // 获取贷款记录
        async getLoanRecords() {
            this.loading = true
            try {
                const params = {}
                if (this.currentStatus !== 'all') {
                    params.status = this.currentStatus
                }
                
                const result = await Fetch('/user/loan_records', params)
                
                if (result.code === 1) {
                    this.loanRecords = result.data.list || []
                } else {
                    Toast.fail(result.info || this.$t('loan.getRecordsFailed'))
                }
            } catch (error) {
                console.error('获取贷款记录失败:', error)
                Toast.fail(this.$t('loan.networkError'))
            } finally {
                this.loading = false
            }
        },

        // 切换状态筛选
        changeStatus(status) {
            this.currentStatus = status
            this.getLoanRecords()
        },

        // 格式化时间
        formatTime(timestamp) {
            if (!timestamp) return '-'
            const date = new Date(timestamp * 1000)
            return date.toLocaleString('zh-CN', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            })
        },

        // 获取状态样式类
        getStatusClass(status) {
            const statusMap = {
                0: 'status_pending',    // 待审核
                1: 'status_approved',   // 审核通过
                2: 'status_rejected'    // 审核拒绝
            }
            return statusMap[status] || 'status_unknown'
        },

        // 获取状态文字
        getStatusText(status) {
            const statusMap = {
                0: this.$t('loan.pending'),    // 待审核
                1: this.$t('loan.approved'),   // 审核通过
                2: this.$t('loan.rejected')    // 审核拒绝
            }
            return statusMap[status] || '-'
        },

        // 还款操作
        async repayLoan(record) {
            try {
                const result = await Fetch('/user/repay_loan', {
                    loan_id: record.id
                })
                
                if (result.code === 1) {
                    Toast.success(this.$t('loan.repaySuccess'))
                    this.getLoanRecords() // 刷新列表
                } else {
                    Toast.fail(result.info || this.$t('loan.repayFailed'))
                }
            } catch (error) {
                console.error('还款失败:', error)
                Toast.fail(this.$t('loan.networkError'))
            }
        }
    }
}
</script>

<style scoped>
.basic_wrap {
    min-height: 100vh;
    background: #f5f5f5;
}

.loan_record_header {
    position: relative;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border-bottom: 1px solid #f0f0f0;

    .back_left {
        position: absolute;
        left: 15px;
        cursor: pointer;

        img {
            width: 16px;
        }
    }

    .big_tit {
        font-size: 16px;
        font-weight: 500;
        color: #333;
    }
}


.filter_section {
    background: #fff;
    padding: 15px;
    margin-bottom: 10px;
}

.filter_tabs {
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
    align-items: center;
}

.tab_item {
    padding: 8px 16px;
    border-radius: 20px;
    background: #f5f5f5;
    color: #666;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s;
    white-space: nowrap;
    flex-shrink: 0;
}

.tab_item.active {
    background: #007aff;
    color: #fff;
}

.main_content {
    padding: 0 15px;
}

.loading_state, .empty_state {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    color: #999;
}

.record_list {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.record_item {
    background: #fff;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.record_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.loan_name {
    font-size: 16px;
    font-weight: 600;
    color: #333;
}

.record_status span {
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
}

.status-pending {
    background: #fff3cd;
    color: #856404;
}

.status-approved {
    background: #d4edda;
    color: #155724;
}

.status-rejected {
    background: #f8d7da;
    color: #721c24;
}

.status-repaid {
    background: #d1ecf1;
    color: #0c5460;
}

.record_details {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.detail_row {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.label {
    color: #666;
    font-size: 14px;
}

.value {
    color: #333;
    font-size: 14px;
    font-weight: 500;
}

.value.amount {
    color: #007aff;
    font-size: 16px;
    font-weight: 600;
}

.value.total {
    color: #ff3b30;
    font-size: 16px;
    font-weight: 600;
}

.record_actions {
    margin-top: 15px;
    display: flex;
    justify-content: flex-end;
}

.repay_btn {
    padding: 8px 20px;
    background: #007aff;
    color: #fff;
    border: none;
    border-radius: 20px;
    font-size: 14px;
    cursor: pointer;
    transition: background 0.3s;
}

.repay_btn:hover {
    background: #0056cc;
}
</style>